import './page.css'

setStudentFeatureSelector()
setTeacherFeatureSelector()
setScheduleFeatureSelector()

function setStudentFeatureSelector () {
  const studentCards = document.querySelectorAll('#student-features .feature-card')
  for (let card of studentCards) {
    card.addEventListener('click', () => {
      if (!card.classList.contains('selected')) {
        let selectedCard = document.querySelector('#student-features .selected')
        selectedCard.classList.remove('selected')
        card.classList.add('selected')
        document.querySelector('#student-features-imgs .active').classList.remove('active')
        document.getElementById(`${card.id}-img`).classList.add('active')
      }
    })
  }
}

function setTeacherFeatureSelector () {
  const teacherCards = document.querySelectorAll('#teacher-features .feature-card')
  for (let card of teacherCards) {
    card.addEventListener('click', () => {
      if (!card.classList.contains('selected')) {
        let selectedCard = document.querySelector('#teacher-features .selected')
        selectedCard.classList.remove('selected')
        card.classList.add('selected')
        document.querySelector('#teacher-features-imgs .active').classList.remove('active')
        document.getElementById(`${card.id}-img`).classList.add('active')
      }
    })
  }
}

function setScheduleFeatureSelector () {
  const scheduleCards = document.querySelectorAll('#schedule-features .feature-card')
  for (let card of scheduleCards) {
    card.addEventListener('click', () => {
      if (!card.classList.contains('selected')) {
        let selectedCard = document.querySelector('#schedule-features .selected')
        selectedCard.classList.remove('selected')
        card.classList.add('selected')
        document.querySelector('#schedule-features-imgs .active').classList.remove('active')
        document.getElementById(`${card.id}-img`).classList.add('active')
      }
    })
  }
}
